import { isMobile } from "react-device-detect"

export const USES_ADAPTIVE_DESIGNER = isMobile
